const userActionTypes = {
    SET_CURRENT_USER : 'SET_CURRENT_USER',
    SET_USER_PHOTO:'SET_USER_PHOTO',
    SET_USER_NAME:'SET_USER_NAME',
    SET_USER_PHONE:'SET_USER_PHONE'
}

export default userActionTypes